import clsx from "clsx";
import * as React from "react";
import type { FontWeightProps } from "../../helper/FontWeightProps.js";

export type CaptionSize = "lg" | "md" | "sm";

interface CaptionProps
  extends React.HTMLAttributes<HTMLParagraphElement>,
    FontWeightProps {
  size?: CaptionSize;
  as?: "p" | "span";
  className?: string;
}

const Caption = React.forwardRef<HTMLParagraphElement, CaptionProps>(
  (props, ref) => {
    const {
      className,
      size = "lg",
      as: Tag = "p",
      fontWeight = "regular",
      ...rest
    } = props;

    return (
      <Tag
        data-size={size}
        data-font-weight={fontWeight}
        className={clsx("ox-reset ox-ui-Caption", className)}
        {...rest}
        ref={ref}
      />
    );
  },
);

Caption.displayName = "Caption";
export { Caption };
export type { CaptionProps };
